import React from 'react';
import { NavLink } from 'react-router-dom';

function normalizePath(path) {
  return path.split('?')[0].toLowerCase();
}

function isPathActive(pathname, to, exact) {
  const current = normalizePath(pathname);
  const target = normalizePath(to);

  if (target === '/') {
    return current === '/';
  }

  if (exact) {
    return current === target;
  }

  return current === target || current.startsWith(`${target}/`);
}

/**
 * Sidebar / offcanvas menu link with active highlighting for the current route.
 */
const SideMenuLink = ({ to, exact, className, children, ...rest }) => {
  return (
    <NavLink
      to={to}
      className={className}
      activeClassName="is-active"
      isActive={(match, location) => {
        if (!match) return false;
        return isPathActive(location.pathname, to, exact);
      }}
      {...rest}
    >
      {children}
    </NavLink>
  );
};

export default SideMenuLink;
